export default "__VITE_ASSET__QACTpP5Z__"